var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2132 0.472778H0.867258C0.818545 0.472778 0.778992 0.512505 0.778992 0.561513V14.3604C0.778992 14.4094 0.818545 14.4491 0.867258 14.4491H15.2132C15.2619 14.4491 15.3012 14.4094 15.3012 14.3604V0.561513C15.3012 0.512505 15.2619 0.472778 15.2132 0.472778Z",
    fill: "#545BE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61713 3.54858V11.3733",
    stroke: "white",
    strokeWidth: 1.26926
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96185 3.54858V7.44616",
    stroke: "white",
    strokeWidth: 1.26685
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74799 3.54883V4.8727H10.9854L12.6084 8.22643H14.0698L11.7488 3.54883H8.74799Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41284 6.30743V11.5287",
    stroke: "white",
    strokeWidth: 1.46628
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4dc6a8a69a01951a42208e174c4b008b.svg";
export { ForwardRef as ReactComponent };